import { render } from "./uiTitle.vue?vue&type=template&id=a5e621dc&scoped=true&ts=true&lang=pug"
import script from "./uiTitle.vue?vue&type=script&lang=ts"
export * from "./uiTitle.vue?vue&type=script&lang=ts"

import "./uiTitle.vue?vue&type=style&index=0&id=a5e621dc&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e621dc"]])

export default __exports__